import { numericExtent, cmfSeries } from "../utils";
const CMF = {
    name: "CMF",
    compute: (bars, period = 20) => cmfSeries(bars, period),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default CMF;
